import { render, staticRenderFns } from "./ThumbnailImg.vue?vue&type=template&id=4b304180&scoped=true&"
import script from "./ThumbnailImg.vue?vue&type=script&lang=js&"
export * from "./ThumbnailImg.vue?vue&type=script&lang=js&"
import style0 from "./ThumbnailImg.vue?vue&type=style&index=0&id=4b304180&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b304180",
  null
  
)

export default component.exports